<form #form="ngForm" autocomplete="off">
    <ng-container *ngIf="employee">
        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label appRemoveAriaOwns>{{ 'language' | translate }}</mat-label>
                <mat-select type="text" required #language="ngModel" [(ngModel)]="employee.language" name="language">
                    <mat-option value="en_CA">{{ 'ENGLISH' | translate }}</mat-option>
                    <mat-option value="fr_CA">{{ 'FRENCH' | translate }}</mat-option>
                </mat-select>
                <mat-error *ngIf="language.invalid">{{ language.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </ng-container>
</form>
